import { render } from "./ExtraField.pug?vue&type=template&id=1e690b0c&lang=pug"
import script from "./ExtraField.js?vue&type=script&lang=js"
export * from "./ExtraField.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__